import { mapToCanActivate, mapToResolve, Routes } from '@angular/router';
import { LocationGuard } from '@next/core-lib/relationships';
import { Observable } from 'rxjs';

import { DeliveryOverviewComponent } from './components/delivery-overview/delivery-overview.component';
import { DeliveryOverviewResolver } from './resolvers/delivery-overview.resolver';

export const DeliveryRoutes = (): Routes => [
  {
    path: '',
    component: DeliveryOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      data: mapToResolve<Observable<boolean>>(DeliveryOverviewResolver),
    },
  },
];
